import { render, staticRenderFns } from "./type2.vue?vue&type=template&id=00bae28d&scoped=true&"
import script from "./type2.vue?vue&type=script&lang=ts&"
export * from "./type2.vue?vue&type=script&lang=ts&"
import style0 from "./type2.vue?vue&type=style&index=0&id=00bae28d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bae28d",
  null
  
)

export default component.exports